/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import PropTypes from 'prop-types';

export default class Contact extends React.PureComponent {
  render() {
    const {
      title,
      role,
      email,
      phone,
      isFooter,
    } = this.props;

    return (
      <li className="Contact">
        <div>
          {isFooter ? (
            <h4 className="Contact__heading">
              <a
                href={`mailto:${email}`}
                target="blank"
                rel="noopener noreferrer"
                className="Contact__heading-link"
              >
                <span
                  className="Contact__title"
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              </a>
            </h4>
          ) : (
            <h2 className="Contact__heading">
              <a
                href={`mailto:${email}`}
                target="blank"
                rel="noopener noreferrer"
                className="Contact__heading-link"
              >
                <span
                  className="Contact__title"
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              </a>
            </h2>
          )}
          <p className="Contact__paragraph">
            <span
              className="Contact__role"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: role }}
            />
          </p>
        </div>
        <div className="Contact__contact">
          <p className="Contact__text">
            <a
              href={`mailto:${email}`}
              className="Contact__link"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: email }}
            />
          </p>
          <p className="Contact__text">
            <a
              href={`tel:${phone}`}
              className="Contact__link"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: phone }}
            />
          </p>
        </div>
      </li>
    );
  }
}

Contact.propTypes = {
  title: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  isFooter: PropTypes.bool,
};

Contact.defaultProps = {
  isFooter: false,
};
